// for custom badge positioning 
(() => {
  const BADGE_SELECTOR = '[data-product-media-badge]';
  const SALE_CLASS = 'is-on-sale';
  const SOLD_OUT_CLASS = 'is-sold-out';

  const applyState = (badge, variant) => {
    badge.classList.remove(SALE_CLASS, SOLD_OUT_CLASS);
    if (!variant) return;
    if (variant.available === false) {
      badge.classList.add(SOLD_OUT_CLASS);
      return;
    }
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      badge.classList.add(SALE_CLASS);
    }
  };

  const updateBadges = (sectionId, variant) => {
    const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
    if (!productInfo) return;
    productInfo.querySelectorAll(BADGE_SELECTOR).forEach((badge) => applyState(badge, variant));
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      updateBadges(data.sectionId, data.variant);
    });
  }
})();
